import { APP_BASE } from '../app/types'

export default {
    appBase: (state, getters, rootState, rootGetters) => rootGetters[APP_BASE],
    hooks: state => [...state.hooks].reverse(),
    plugins: state => state.plugins.map(item => ({
        ...item,
        isLastest: item.currentVersion === item.lastestVersion
    }))
}
